import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteThemeMutation = createMutationHook(ShopRendererApiClient.deleteTheme, {
  mutationKey: ['deleteTheme'],
})
